module.exports = __webpack_public_path__ + "static/media/City of Atlanta template.4935040a.xlsx";